import helper from '../lib/helper'
import { currentUser } from '@/lib/user'

export default {

    data () {
        return {
            showAuthPopup: false,
            loginStatus: false
        }
    },

    mounted () {
        window.addEventListener('auth-show', () => {
            this.showAuthPopup = true
        })
    },

    methods: {

        clickToMyQuiz () {
            window.location.href = this.$router.resolve({name: 'my-quiz'}).href
        },

        clickNewQuiz () {
            if (this.$route.name == 'my-quiz') {
                this.$emit('open-quiz-creator')
            } else {
                if (this.$route.name === 'skoler-purchase') {
                    window.location.href = this.$router.resolve({name: 'login-skoler', query: { path: btoa('/my-quiz?create=true&type=normal') }}).href
                } else {
                    window.location.href = this.$router.resolve({name: 'my-quiz', query: { create: true, type: 'normal' }}).href
                }
            }

            // window.location.href = this.$router.resolve({name: 'setting'}).href
        },

        clickEditProfile () {
            window.location.href = this.$router.resolve({name: 'me'}).href
        },

        clickOrder () {
            window.location.href = this.$router.resolve({name: 'order'}).href
        },

        clickSubpage (page) {
            window.location.href = this.$router.resolve({name: page}).href
        },

        clickSubscribePlan () {
            if (currentUser()) {
                if (currentUser().provider === 'feide') {
                    return window.location.href = this.$router.resolve({name: 'skoler-purchase'}).href
                }

                if (currentUser().role.includes('teacher')) {
                    return window.location.href = this.$router.resolve({name: 'school-purchase'}).href
                }
            }

            if (this.isSkolerPage()) {
                return window.location.href = this.$router.resolve({name: 'skoler-purchase'}).href
            }

            if (this.isSchoolPage()) {
                return window.location.href = this.$router.resolve({name: 'school-purchase'}).href
            }

            return window.location.href = this.$router.resolve({name: 'purchase'}).href
        },

        clickBuyCredit () {
            window.location.href = this.$router.resolve({name: 'buy-credit'}).href
        },

        loginSuccess (user, sponsor, isShowNewsletter) {
            if (!sponsor && isShowNewsletter) {
                this.showAuthPopup = false
            }
            this.loginStatus = true
            this.afterLoginSuccess(user)
            this.$store.dispatch('getCredit')
            this.$store.dispatch('findOrderAbility')
        },

        afterLoginSuccess () {

        },

        createWebviewRedirectTo() {
            return window.location.href
        },

        trackPay (payment, label) {

            if (payment == 'stripe-checkout') {
                payment = 'stripe'
            }

            helper.gTrackEvent('payed', {
                'event_category': `Payed_${payment}`,
                'event_label': label
            })
        },

        openNewsletterPopup() {
            if (typeof this.joinMenu != 'undefined') { // playAloneSummary only
                this.joinMenu = false
            }
            this.showAuthPopup = true

            this.$nextTick(() => {
                this.$refs.authPopup.openNewsletterModal()
            })
        },
    }
}
